"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryPaginator = void 0;
var tslib_1 = require("tslib");
var client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
var DynamoDbPaginator_1 = require("./DynamoDbPaginator");
var QueryPaginator = /** @class */ (function (_super) {
    tslib_1.__extends(QueryPaginator, _super);
    function QueryPaginator(client, input, limit) {
        var _this = _super.call(this, limit) || this;
        _this.client = client;
        _this.nextRequest = tslib_1.__assign({}, input);
        return _this;
    }
    QueryPaginator.prototype.getNext = function () {
        var _this = this;
        if (this.nextRequest) {
            return this.client.send(new client_dynamodb_1.QueryCommand(tslib_1.__assign(tslib_1.__assign({}, this.nextRequest), { Limit: this.getNextPageSize(this.nextRequest.Limit) })))
                .then(function (output) {
                if (_this.nextRequest && output.LastEvaluatedKey) {
                    _this.nextRequest = tslib_1.__assign(tslib_1.__assign({}, _this.nextRequest), { ExclusiveStartKey: output.LastEvaluatedKey });
                }
                else {
                    _this.nextRequest = undefined;
                }
                return Promise.resolve({
                    value: output,
                    done: false
                });
            });
        }
        return Promise.resolve({ done: true });
    };
    return QueryPaginator;
}(DynamoDbPaginator_1.DynamoDbPaginator));
exports.QueryPaginator = QueryPaginator;
